import React, { useMemo } from 'react';
import webApp from '@happylife-a/web-app';
import webCore from '@happylife-a/web-core';
import { IconButton, Icon, Flex } from '@chakra-ui/react';

export default function FavoriteButtonV3({ productDetailId, onToggle, isOutOfStock }) {
  const { isFavorite, favorites } = webCore.contexts.useFavorites();

  const isFavoriteItem = useMemo(
    () => isFavorite(productDetailId),
    [isFavorite, productDetailId, favorites?.ids]
  );

  const onClick = (e) => {
    e.preventDefault();
    if (onToggle) {
      onToggle();
    }
  };

  return (
    <IconButton
      variant="transparent"
      isDisabled={isOutOfStock}
      minW="32px"
      maxW="32px"
      minH="32px"
      maxH="32px"
      bg="black"
      borderRadius="50%"
      justifyContent="center"
      alignItems="center"
      icon={
        <Icon
          as={webApp.theme.icons.FavoriteIcon}
          fill={isFavoriteItem ? 'white' : 'none'}
          stroke={isFavoriteItem ? 'white' : 'white'}
          h="16px"
          w="16px"
        />
      }
      onClick={onClick}
    />
  );
}
